import { render, staticRenderFns } from "./productsDetail.vue?vue&type=template&id=cf6480a4&scoped=true&"
import script from "./productsDetail.vue?vue&type=script&lang=js&"
export * from "./productsDetail.vue?vue&type=script&lang=js&"
import style0 from "./productsDetail.vue?vue&type=style&index=0&id=cf6480a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6480a4",
  null
  
)

export default component.exports